// extracted by mini-css-extract-plugin
export default {"remove":"BadgeComponent_remove__kvhep","imageAligned":"BadgeComponent_imageAligned__SAN0N"};